import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../lib/auth';
import { Button, ErrorAlert } from '../components/ui';

export function LoginPage() {
  const { login, magicLogin } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const magicLinkStarted = useRef(false);

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get('magic');
    if (!token || magicLinkStarted.current) return;
    magicLinkStarted.current = true;
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    setBusy(true);
    setError(null);
    void magicLogin(token).catch(setError).finally(() => setBusy(false));
  }, [magicLogin]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--bg)',
        padding: 20,
      }}
    >
      <div className="card" style={{ width: '100%', maxWidth: 400 }}>
        <div className="card__body">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <span className="sidebar__logo" style={{ width: 34, height: 34 }}>
              K
            </span>
            <h1 style={{ margin: 0, fontSize: 20 }}>Kontentowo</h1>
          </div>
          <p className="muted" style={{ marginBottom: 18 }}>
            Content Operating System
          </p>
          <ErrorAlert error={error} />
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="field" style={{ margin: 0 }}>
              <label className="field__label">Email</label>
              <input
                className="input"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>
            <div className="field" style={{ margin: 0 }}>
              <label className="field__label">Hasło</label>
              <input
                className="input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <Button variant="primary" type="submit" disabled={busy || !email || !password}>
              {busy ? 'Logowanie…' : 'Zaloguj się'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
